export const blockIconsAudioandvideoSubscriptions = (
	<span className='material-symbols-outlined'>subscriptions</span>
);
